<template>
  <div
    style="padding: 0 8px"
    v-loading="loading"
    element-loading-text="图片上传中......"
    :class="{detail_main:isActive}">
    <el-row :gutter="10">
      <el-col :span="18">
        <div v-if="item.purchase_no !== null ">
          <span style="font-weight: bold">采购单号: </span>{{ item.purchase_no }}
        </div>
        <div v-else>
          <span style="font-weight: bold">采购单号: </span>补货
        </div>
        <div>
          <span style="font-weight: bold">采购员: </span>{{ item.auth?item.auth.username:'' }}
        </div>
        <div>
          <span style="font-weight: bold">订单编号: </span>{{ item.order_number }}
        </div>
        <div><span style="font-weight: bold">交易编号: </span>{{ item.transaction_no }}</div>

      </el-col>
      <el-col :span="6" style="line-height: 30px" >
        <div v-if="item.partition_name">
          <span > {{ item.partition_name }} 区 </span>
        </div>
        <div  style="color: #3967FF">
          <span v-if=" item.sub_table && item.sub_table.country != null ">国家: {{ item.sub_table.country }} </span>
          <span v-else>国家: 无</span>
        </div>
      </el-col>
    </el-row>


    <div class="show">
      <div class="line">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple"
                 style="color: #bd2c00">
              <h3>多品编号</h3>
              <p>{{ item.transaction_number }}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <h3>SKU</h3>
              <p>{{ item.sku }}</p>
            </div>
          </el-col>
          <div v-if="item.status !== 6 ">
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <h3>数量</h3>
                <p style="color:  #bd2c00">{{ item.quantity }}</p>
              </div>
            </el-col>
          </div>
          <div v-else-if="item.status === 6 ">
            <el-col :span="6">
              <div class="grid-content bg-purple-light">
                <h3>数量</h3>
                <p style="color:  #bd2c00">{{ item.quantity }}</p>
              </div>
            </el-col>
            <el-col :span="6" v-if="item.arrival_quantity!==null">
              <div class="grid-content bg-purple-light">
                <h3>待验收数量</h3>
                <p style="color:  #bd2c00">{{ item.quantity - item.arrival_quantity - item.abnormal_quantity}}</p>
              </div>
            </el-col>
            <el-col :span="6" v-if="item.arrival_quantity!==null">
              <div class="grid-content bg-purple-light">
                <h3>异常数</h3>
                <p style="color:  #bd2c00">{{ item.abnormal_quantity }}</p>
              </div>
            </el-col>
            <el-col :span="6" v-if="item.arrival_quantity!==null">
              <div class="grid-content bg-purple-light">
                <h3>完成数</h3>
                <p style="color:  #bd2c00">{{ item.arrival_quantity }}</p>
              </div>
            </el-col>
          </div>


          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <h3>商品中文名称</h3>
              <p>{{ item.product_name }}</p>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{ item.word }}</span></p>
            </div>
            <div class="status_card" v-if="card_status == 0">有卡片</div>
            <div class="status_card" v-else-if="card_status == 8">已拣卡</div>
          </el-col>
          <el-col :span="24" v-if="item.remark">
            <div class="grid-content bg-purple-light">
              <!--<p>备注:</p>-->
              <p><span style="font-weight: bold">备注</span>: <span>{{ item.remark }}</span></p>
            </div>
          </el-col>

          <template v-if="item.shelf_id===null">
            <el-col :span="24" v-if="item.history_shelf_id!==null">
              <div class="grid-content bg-purple-light">
                <p>历史货架号: {{ item.history_shelf.shelf_no }} </p>
              </div>
            </el-col>
          </template>

          <el-col :span="24" v-if="item.accept_at">
            <div class="grid-content bg-purple-light">
              <p>时间: {{ item.accept_at }} </p>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="grid-content bg-purple-light" style="line-height: 36px;font-size: 18px">
              <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
              <p v-else-if="item.status===1">状态: <span style="color: #55a532">完 成</span></p>
              <p v-else-if="item.status===2">状态: <span style="color: red">异 常</span></p>
              <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
              <p v-else-if="item.status===4">状态: <span style="color: red">锁单</span></p>
              <p v-else-if="item.status===5">状态: <span style="color: red">作废</span></p>
              <p v-else-if="item.status===6">状态: <span style="color: red">缺货</span></p>
              <p v-else>状态: 其 它</p>
            </div>
          </el-col>

          <el-col :span="12" v-if="item.status !=6">
            <div>
              <el-button icon="el-icon-check" size="medium" type="primary" @click.prevent="onSubmit(1)">完成</el-button>
            </div>
          </el-col>

          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <div class="pd-img">
                <img :src="item.image_url" alt="" preview="1" preview-text='图片展示'/>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>

    <div class="check-box" v-if="item.status !=6">
      <el-form ref="form" :model="form" label-width="50px">
        <template v-if="fast_remark">
          <el-form-item label="备注">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="备注">
            <el-select v-model="form.remark" clearable placeholder="请选择快速备注信息">
              <el-option label="定制文案错误" value="定制文案错误"></el-option>
              <el-option label="尺码错误" value="尺码错误"></el-option>
              <el-option label="确认文案正确" value="确认文案正确"></el-option>
              <el-option label="产品破损" value="产品破损"></el-option>
              <el-option label="文案不全" value="文案不全"></el-option>
              <el-option label="文案模糊" value="文案模糊"></el-option>
              <el-option label="图片不清晰" value="图片不清晰"></el-option>
              <el-option label="旧单在此验收，未丢失，确认为正确的产品" value="旧单在此验收，未丢失，确认为正确的产品"></el-option>
              <el-option label="旧单在此验收，下重单，确认为正确的产品" value="旧单在此验收，下重单，确认为正确的产品"></el-option>
<!--              <el-option label="到货1个" value="到货1个"></el-option>-->
<!--              <el-option label="到货2个" value="到货2个"></el-option>-->
              <!--<el-option label="定制信息错误" value="定制信息错误"></el-option>-->
              <!--<el-option label="产品破损" value="产品破损"></el-option>-->
              <!--<el-option label="数量不对" value="数量不对"></el-option>-->
              <!--<el-option label="印刷质量差" value="印刷质量差"></el-option>-->
              <!--<el-option label="其它" value="其它"></el-option>-->
              <!--<el-option label="移除备注" value=""></el-option>-->
            </el-select>
          </el-form-item>
        </template>

        <div style="position: relative" v-if="item.status !=6">

          <div class="remark-button">
            <el-button type="info" size="small" @click.prevent="fast_remark=!fast_remark" v-if="fast_remark">切换到快速备注
            </el-button>
            <el-button type="warning" size="small" @click.prevent="fast_remark=!fast_remark" v-else>切换到自定义备注</el-button>
          </div>

          <!--上传图片-->
          <el-upload
            class="upload-demo"
            action="#"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            list-type="picture"
            :limit="3"
            :on-success="handleSuccess"
            :auto-upload='false'
            :on-change="handleChange"
            :on-exceed="handleExceed"
          >
            <el-button size="small" type="primary" style="margin-left: 10px" >上传图片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过3张</div>
          </el-upload>
        </div>




      </el-form>
    </div>




    <el-row class="button-box">
      <el-button style="margin-bottom: 1rem" type="primary" @click.prevent="onSubmit(1)" v-if="item.status !=6">完成</el-button>
      <el-button style="margin-bottom: 1rem;" type="danger" @click.prevent="onSubmit(2)" v-if="item.status !=6">异常</el-button>
      <el-button style="margin-bottom: 1rem;" type="info" @click.prevent="arrivalHandAdd(true)" v-if="item.status !=6&&item.quantity>1">按数量验收</el-button>
      <el-button  type="info" @click.prevent="arrivalHandAdd(true)" v-else-if="item.status ==6">按数量验收</el-button>
    </el-row>

    <div class="wav">
      <audio id="audioMusic" class="audio" src="@/assets/wav/didi.wav" controls hidden="true" ref="audio"></audio>
      <audio id="failMusic" class="audio" src="@/assets/wav/yichang.wav" controls hidden="true" ref="audio"></audio>
    </div>

    <el-dialog
        title="填写到货数量"
        :visible.sync="arrivalVisible"
        width="80%"
    >
      <v-arrivalQuantity :quantity="item.quantity"  @arrivalHand="arrivalHand" ></v-arrivalQuantity>
    </el-dialog>

    <div v-if="tableData.length">
      <span style="font-weight: bold">验收记录: </span>
      <el-table

          :data="tableData"
          stripe
          style="max-width: 100%;margin-top: 10px;"
          @row-click="changeSonStatus($event)"
          class="custom-table"
        >
        <el-table-column
            prop="quantity"
            label="数量"
            >
        </el-table-column>
        <el-table-column
            prop="status"
            label="状态"
            :filters="[{ text: '完成', value: '完成' }, { text: '异常', value: '异常' }]"
            >
          <template slot-scope="scope">
          <el-tag
              :type="scope.row.status === '完成' ? 'primary' : 'danger'"
              disable-transitions>{{scope.row.status}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="remark"
            label="备注"
            >
        </el-table-column>
        <el-table-column
            prop="is_up"
            label="上架"
            >
        </el-table-column>
      </el-table>
    </div>


    <div>
      <el-dialog :visible.sync="showOldOrderTipsHand" title="请选择采购单号" width="80%" :close-on-click-modal="false" :show-close="false">
        <el-select v-model="selectedPurchaseDetailId" placeholder="请选择">
          <el-option :label="this.item.purchase_no" :value="this.item.id"></el-option>
          <template v-for="(oOrder, index) in this.oldOrder">
            <el-option :label="oOrder.purchase_no" :value="oOrder.id" :key="index" :index="index"></el-option>
          </template>
        </el-select>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmSelection()">确认</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import Bus from '@/assets/js/bus';
import {getToken} from "@/utils/auth";
import {uploadImage} from "../../../utils/fileUpload";
import vArrivalQuantity from "./ArrivalQuantity";
export default {
  name: "Detail",
  components:{
    vArrivalQuantity
  },
  data() {
    return {
      //是否有卡片
      card_status:-1,
      //新旧订单产生的弹窗
      selectedPurchaseDetailId:0,
      selectedPurchaseDetailPurchaseNo:'',
      showOldOrderTipsHand:false,
      oldOrder:[],
      // isActive:false,
      //缺货弹窗和到货数量
      arrivalVisible:false,
      son_id:0,
      arrival_quantity:0,
      son_status:0,
      tableData:[],

      loading: false,
      fast_remark: false,
      item: {},
      form: {
        // remark:this.$route.query.remark,
        remark: '',
        // shelf_id:this.$route.query.lock_shelf?this.$route.query.lock_shelf:this.$route.query.shelf_id
        // shelf_id: ''
      },
      shelves: [],
      // lock:!!this.$route.query.lock_shelf
      // lock:""

      fileList: [],
      imgList: [],
      headers: {
        Authorization: getToken(),
      },
      uploadImgUrl: this.api.file_upload, // 上传图片的后台controller的地址
      //判断是否延迟展示弹窗
      later_show_note:false,
      //判断是否为第一次点击
      is_first_click_check:true,
    }
  },
  methods: {
    arrivalHandAdd(bool){
      this.son_id =0;
      this.arrivalHand(bool);
    },
    changeSonStatus(obj){
      if(obj.is_up == '是'){
        const h = this.$createElement;
        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '该记录已上架无法修改 '),
            // h('i', { style: 'color: teal' }, 'VNode')
          ])
        });
        return false;
      }else{
        this.son_id = obj.id;
        this.arrivalHand(true);
      }

    },
    arrivalHand(bool,arrival_quantity = 0,son_status,fileList,remark){
      this.arrivalVisible = bool;
      if(!bool){
        this.son_status = son_status;
        this.fileList = fileList;
        this.form.remark = remark;
        this.arrival_quantity = arrival_quantity;
        this.onSubmit(6);
      }
    },
    open() {
      let _this = this
      this.$alert(_this.item.show_note, '提示', {
        confirmButtonText: '确定',
        customClass:'alt_css'
      });
    },
    latestSecurityIncidents() {
      //同时 触发提示音
      document.getElementById('audioMusic').play();
    },

    failMusic() {
      document.getElementById('failMusic').play();
    },

    onSubmit(s) {
      //增加判断是否为重复操作
      if( this.item.accept_at != null && this.item.status == s && this.item.status !=6){
        let now = new Date(); // 获取当前时间
        let timestampDate = new Date(this.item.accept_at); // 将时间戳转换为Date对象
        let timeDifference = now - timestampDate; // 计算时间差（毫秒）
        let oneHourInMilliseconds = 60 * 60 * 1000; // 一小时的毫秒数
        if( timeDifference > oneHourInMilliseconds ){
          if(this.is_first_click_check){
            this.is_first_click_check = false;
            alert('重复录入！请核对产品、检查采购单和前单,填写备注信息');
            return false;
          }else if(this.form.remark === ''){
            alert('重复录入！必须填入备注信息');
            return false;
          }
        }

      }

      if( this.item.status == 2 && (s == 1 || s == 6) ){
          if(this.form.remark === ''){
            alert('异常状态更改，请输入备注说明');
            return false;
          }
      }

      if (s === 1) {
        this.latestSecurityIncidents()
      }

      if (s === 2) {
        this.form.remark = this.form.remark.trim();
        if (this.item.remark === null) {
          if (this.form.remark == null || this.form.remark === '') {
            const h = this.$createElement;
            this.$message({
              offset: 50,
              duration: 3000,
              message: h('p', null, [
                h('span', null, '异常订单请填写备注信息 '),
                // h('i', { style: 'color: teal' }, 'VNode')
              ])
            });
            return false;
          }
        }

        this.failMusic()
      }
      // alert(35)




      let param = {
        id: this.item.id,
        status: s,

      }
      if(s === 6){
        if(this.arrival_quantity <= 0 || this.arrival_quantity > this.item.quantity ){
          alert('请输入正确的到货数量');
          return
        }
        param = {
          id: this.item.id,
          status: s,
          arrival_quantity:this.arrival_quantity,
          son_status:this.son_status,
          son_id:this.son_id
        }
      }
      let date = this.getDate()
      if (this.item.remark === null) {
        if (this.form.remark !== "") {
          param.remark = this.form.remark + date + ";"
        }
      } else {
        if (this.form.remark !== "") {
          param.remark = this.form.remark + date + ";" + this.item.remark
        } else {
          param.remark = this.item.remark
        }
      }

      if (this.fileList !== []) {
        let imgList = []
        this.fileList.forEach(function (value) {
          if (value.id === undefined) {
            imgList.push(value.filename)
          }
        })

        param.imgList = imgList

      }
      //报废处理
      if(s==8){
        param.id = this.selectedPurchaseDetailId;
      }
      //获取是否要将改单设置到采购单内
      param.set_purchase = 0;
      if (!this.is_first_click_check){
        param.set_purchase = 1;
      }
      console.log(param)
      this.http.fetchPost(this.api.check, param).then((res) => {
        console.log(res)
        let data = res.data
        if (data.code === 200) {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 1000,
            message: h('p', null, [
              h('span', null, '提交成功 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
          let _this = this
          setTimeout(function () {
            _this.$router.push({
              path: "/check",
              query: {
                order_number: _this.item.order_number
              }

            })
          }, 1000)

        }
      }).catch(err => {
        console.log(err)
      })

    },
    getShelf() {
      this.http.fetchGet(this.api.getShelfUrl).then((res) => {
        let data = res.data
        if (data.code === 200) {

          this.shelves = data.data


        } else {
          this.$message.error("获取仓库列表失败,请刷新页面")
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 图片上传
    handleSuccess(response, file, fileList) {
      console.log(response)
      console.log(file)
      console.log(fileList)
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
      let param = {
        filename: file.filename
      }

      if (file.id !== undefined) {
        param.id = file.id
      }

      // 执行图片删除
      this.http.fetchDel(this.api.file_delete, param).then(res => {
        console.log(res)
      }).catch(err => {
        console.log(err);
      })

      this.fileList = fileList

      console.log(this.fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(){
      this.$message.error('最多只能上传3张图片');
    },
    handleChange(file, fileList) {
      // 压缩图片
      this.loading = true;
      this.compressImage(file.raw).then(compressedBlob => {
        // 创建 FormData 对象
        const fd = new FormData();
        fd.append('file', compressedBlob, file.name);

        // 上传压缩后的图片
        uploadImage(this.api.file_upload, fd).then(res => {
          // 处理上传成功的逻辑
          if (res.code === 200) {
            this.imgList.push(res.data.filename);

            // 更新文件列表中对应文件的文件名
            for (let i = 0; i < fileList.length; i++) {
              if (fileList[i].uid === file.uid) {
                fileList[i].filename = res.data.filename;
              }
            }
            this.fileList = fileList;
            this.loading = false;
          }
        }).catch(error => {
          // 处理上传失败的逻辑
          console.error(error);
        });
      }).catch(error => {
        // 处理图片压缩失败的逻辑
        console.error(error);
      });
    },
    compressImage(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function(event) {
          const image = new Image();
          image.onload = function() {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            // 设置压缩后的图片宽度和高度
            const maxSideLength = 800; // 设置最大边长为800px
            let width = image.width;
            let height = image.height;
            if (width > height && width > maxSideLength) {
              height *= maxSideLength / width;
              width = maxSideLength;
            } else if (height > maxSideLength) {
              width *= maxSideLength / height;
              height = maxSideLength;
            }
            // 绘制压缩后的图片
            canvas.width = width;
            canvas.height = height;
            context.drawImage(image, 0, 0, width, height);
            // 将 canvas 转换为 Blob 对象，用于上传
            canvas.toBlob(resolve, file.type,0.7);
          };
          image.onerror = reject;
          image.src = event.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    getDate(){
      const now = new Date();
      const year = now.getFullYear(); // 年份
      const month = now.getMonth() + 1; // 月份，需要加1，因为getMonth()返回的是0到11
      const day = now.getDate(); // 日期
      return `${year}-${month}-${day}`;
    },

    showOldOrderTips(oldData,data){
      //设置
      this.selectedPurchaseDetailId = data.id;
      this.oldOrder = oldData;
      if(oldData.length>0){
        this.showOldOrderTipsHand = true;
      }
    },
    confirmSelection(){
      if( this.selectedPurchaseDetailId == this.item.id){
        this.showOldOrderTipsHand = false;
        if(this.later_show_note){
          this.open();
        }
      }else{
        var oData =this.oldOrder;
        var old_purchase_no = '';
        for(var i in oData){
          if(oData[i].id == this.selectedPurchaseDetailId){
            old_purchase_no = oData[i].purchase_no;
          }
        }

        this.$confirm("请注意选择要报废的采购单号是"+old_purchase_no+";如果确认不需要报废，请点击“取消”返回；", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          customClass:'old-order-select',
          closeOnClickModal:false,
        }).then(() => {
          //对订单进行报废处理
          this.onSubmit(8);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消报废'
          });
        });
      }
    },
  },
  created() {
    let _this = this
    let user_info = JSON.parse(localStorage.getItem('user_info'));
    this.$EventBus.$off("order").$on("order", res => {
      console.log(res)
      _this.item = res;
      _this.card_status = _this.item.card_status;
      //判断是否需要展示报废选项
      if(_this.item.old_order_tips){
        if(_this.item.show_note !== null && _this.item.status != 1 && _this.item.status != 6){
          this.later_show_note = true;
        }
        _this.showOldOrderTips(_this.item.old_order_tips,_this.item)
      }else{
        if(_this.item.show_note !== null && _this.item.status != 1 && _this.item.status != 6){
          _this.open();
        }
      }

      // _this.form.remark = _this.item.remark;
      _this.fileList = _this.item.abnormal_images;
      _this.tableData = _this.item.detail_items;
      // _this.form.shelf_id = _this.item.lock_shelf ? this.item.lock_shelf : this.item.shelf_id;
      // console.log(_this.item.order_number)

      //判断是否为厦门工厂
      if( _this.item.is_amoy == 1 && user_info['depot'] == 1 ){
        _this.$alert('该产品需要发往深圳！', '提示', {
          confirmButtonText: '确定',
          customClass:'alt_css'
        });
      }

    })
  },
  computed: {
    // item(){
    //   // console.log(this.$route.query)
    //   return this.$route.query
    // },
    isActive() {
      return this.item.is_change === 1;
    }

    /*lock() {
      return !!this.item.lock_shelf
    },*/

    /*shelf_off() {
      return this.item.shelf_off == 1;
    }*/
  },
  mounted() {

    /* Bus.$off("order")
     Bus.$on("order",res=>{
       console.log(res)
       this.item=res;
       console.log(this.item.order_number)
     })*/

    //或者货架信息
    // this.getShelf()
    //第二种方法
    document.onkeydown = () => {
      let key = window.event.keyCode;
      // alert(key)
      // console.log(key)
      if (key === 73) {
        this.onSubmit(1)
      }
    }
  },
}
</script>
<style>
.status_card{
  position: absolute;
  color: red;
  top: 135px;
  right: 17px;
  border: 1px solid red;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border-radius: 50%;
  font-size: 28px;
}
.old-order-select {
  width: 300px!important;
}
</style>
<style scoped lang="stylus">

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.detail_main
  background-color #fbfa90c4

.show {
  //float: left;
  width: 100%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 100%;

    .pd-img {
      img {
        width 100%
      }
    }

    .el-col {
      //margin-top 5px
      margin-bottom: 5px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


.check-box {
  margin-top 5px

  .el-select {
    width 100%
  }
}

.button-box
  text-align center
  margin-top 15px
  display flex
  justify-content space-evenly

.remark-button
  position absolute
  top 0
  left 110px

//.custom-table .el-table__row--striped td
//  background-color: #409eff96!important; /* 修改为你想要的颜色 */


</style>
